import { IRequestWhitelabel, IWhitelabel } from '@/Interfaces/Whitelabels/Whitelabel.interface';
import { WHITELABELS_ENDPOINT } from '@/constants/endpoints';
import axios from 'axios';

export const createWhitelabel = async (payload: Partial<IRequestWhitelabel>) => {
  return await axios.postForm(WHITELABELS_ENDPOINT, payload);
};

export const updateWhitelabel = async (
  payload: Partial<IRequestWhitelabel>,
  whitelabelId: number,
): Promise<IWhitelabel> => {
  const response = await axios.putForm(`${WHITELABELS_ENDPOINT}/${whitelabelId}`, payload);

  return response.data;
};
